import { FullPageMessageProps } from '@graphcommerce/next-ui'
import { Trans } from '@lingui/react'
import React from 'react'
import { RelatedProductGroups } from '../../Amasty/RelatedProductGroups'
import { Button } from '../../Button'
import { StandardButton } from '../../Button/ButtonStyles'
import { Icon } from '../../Layout/Icon'

type EmptyCartProps = {
  children?: React.ReactNode
  onClose: () => unknown
  displayOnMiniCart?: boolean
} & Pick<FullPageMessageProps, 'button'>

export function EmptyCart(props: EmptyCartProps) {
  const { children, button, onClose, displayOnMiniCart } = props

  return (
    <div>
      <div className='mb-[267px] mt-[118px] text-center'>
        <Icon name='shopping_bag' className='text-[55px]' />
        <p className='Type-H4-Bold mb-[83px] mt-[27px]'>
          <Trans id='Your cart is empty' />
        </p>
        <StandardButton
          type='button'
          className='w-full max-w-[350px] bg-material-ui-blue uppercase md:w-auto'
          variant='contained'
          onClick={onClose}
        >
          <Trans id='Keep Shopping' />
        </StandardButton>
      </div>
      <div className='px-[20px]'>
        <RelatedProductGroups
          position='home_bottom'
          classes={{
            list: `${
              displayOnMiniCart
                ? 'grid grid-cols-2'
                : 'grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5'
            } gap-[40px]`,
          }}
        />
      </div>
    </div>
  )
}
